module.exports = __webpack_public_path__ + "static/media/person-sign.b2561588.svg";